import React, { Fragment, useContext, useEffect } from 'react';
import { Grid, Button, Paper, Typography } from '@material-ui/core';
import { useStyles } from '../styles/CardStyles';
import ChangePinSuccess from '../components/success/ChangePinSuccess';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import Spinner from '../components/spinner/Spinner';
import Header from '../components/header/Header';

const ChangePinAcknowledgement = () => {
  const classes = useStyles(); //Use Styles from styles/styles.js
  const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
  const {
    applicationDetails,
    noOfUploadedDocs,
    noOfRequiredDocs,
    noOfSubmittedDocs,
    submitDocuments,
    errors,
    nextStep,
    selectedVideoCallSchedule,
    selectedDisplayVideoCallSchedule
  } = documentUploadContext;

  useEffect(() => {

  }, [noOfSubmittedDocs, noOfRequiredDocs]);

  useEffect(() => {
    if (errors === 'error') {
      nextStep(2);
    } 
  }, [errors]);
  return (
    <div>
      <Header page={5} />
      <div className={classes.banner}>
        <Paper elevation={3} className={classes.acknowledgementpaper}>
          <Fragment>
              <ChangePinSuccess severity={'success'} />
              <Grid
                container
                direction='row'
                justify='center'
                alignItems='center'
              >
                <Grid item md={2}>
                  <Button
                    className={classes.acknowledgementButton}
                    variant='contained'
                    color='primary'
                    href='/'
                  >
                    Back to Home Page
                  </Button>
                </Grid>
              </Grid>
            </Fragment>
        </Paper>
      </div>
    </div>
  );
};

export default ChangePinAcknowledgement;
